'use client'

import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import Image from 'next/image'
import { Col, Container, Row } from 'react-bootstrap'
import InfraConstruction from '@/assets/home/industries/Infra & Construction.webp'
import Machinery from '@/assets/home/industries/Machinery & Equipment.webp'
import AutoTransport from '@/assets/home/industries/Automotive & Transportation.webp'
import Renew from '@/assets/home/industries/Renewable Energy.webp'
import DefenseAerospace from '@/assets/home/industries/Defense & Aerospace.webp'
import OilGas from '@/assets/home/industries/Oil & Gas.webp'
import ConsumerDurables from '@/assets/home/industries/Consumer Durables.webp'
import ElectricVehicles from '@/assets/home/industries/Electric vehicle.webp'
import Solar from '@/assets/home/industries/solar.webp'
import Link from 'next/link'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'
const indusrtiesData = [
	{
		slug: 'solar-solutions',
		img: Solar,
		title: 'Solar',
	},
	{
		slug: 'defense-and-aerospace',
		img: DefenseAerospace,
		title: 'Defense & Aerospace',
	},
	{
		slug: 'electric-vehicles',
		img: ElectricVehicles,
		title: 'Electric Vehicles',
	},
	{
		slug: 'oil-and-gas',
		img: OilGas,
		title: 'Oil & Gas',
	},
	{
		slug: 'renewable-energy',
		img: Renew,
		title: 'Renewable Energy',
	},
	{
		slug: 'infra-and-construction',
		img: InfraConstruction,
		title: 'Infra & Construction',
	},
	{
		slug: 'machinery-and-equipment',
		img: Machinery,
		title: 'Machinery & Equipment',
	},
	{
		slug: 'automotive-and-transportation',
		img: AutoTransport,
		title: 'Automotive & Transportation',
	},
	{
		slug: '',
		img: ConsumerDurables,
		title: 'Consumer Durables',
	},
]

const Industries = () => {
	return (
		<Container className='industries-section'>
			<div className='industries-section__header'>
				<div className='industries-section__content'>
					<h2 className='industries-section__title'>Industries we serve</h2>
					<p className='industries-section__description'>
						We serve and support diverse industries by delivering innovative solutions that enhance efficiency, quality, and scalability
						throughout their supply chains, ensuring optimal performance and competitive advantage.
					</p>
				</div>
			</div>

			<div className='industries-section__slider-wrapper'>
				<Swiper
					modules={[Navigation]}
					spaceBetween={24}
					slidesPerView={1.2}
					navigation={{
						nextEl: '.swiper-button-next-custom',
						prevEl: '.swiper-button-prev-custom',
					}}
					breakpoints={{
						576: { slidesPerView: 2.2, spaceBetween: 20 },
						768: { slidesPerView: 2.5, spaceBetween: 30 },
						1024: { slidesPerView: 3.5, spaceBetween: 24 },
					}}
				>
					{indusrtiesData.map((item, index) => (
						<SwiperSlide key={`industry-${index}`}>
							{!!item.slug ? (
								<Link href={`/industry/${item.slug}`}>
									<IndustryCard img={item.img} title={item.title} />
								</Link>
							) : (
								<IndustryCard img={item.img} title={item.title} />
							)}
						</SwiperSlide>
					))}
				</Swiper>
				<button className='swiper-button-prev-custom' aria-label='Previous slide'>
					<LuChevronLeft className='btn-icon' />
				</button>
				<button className='swiper-button-next-custom' aria-label='Next slide'>
					<LuChevronRight className='btn-icon' />
				</button>
			</div>
		</Container>
	)
}

export default Industries

function IndustryCard({ title, img }) {
	return (
		<div className='industry-card'>
			<Image
				alt={title}
				src={img}
				className='industry-card__image'
				fill // Use Next.js Image 'fill' prop for better performance with parent relative containers
				sizes='(max-width: 768px) 80vw, (max-width: 1200px) 40vw, 33vw' // Recommended for 'fill'
			/>
			<h5 className='industry-card__title'>{title}</h5>
		</div>
	)
}
